import ContactService from '../../../../services/contact_service';
import ProfessionalService from '../../../../services/professional_service';
import StudentService from '../../../../services/student_service';
import ContactThematicAreaService from '../../../../services/contactThematicArea_service';

const CreateFlow = (vm) => {
  const isAdminCreate = (vm.permissions ?? []).length > 0;

  const saveProfessionalOrStudentCreate = async (contactId, registrationToken) => {
    try {
      if (vm.formDataUser.stage === 'Profesional') {
        await ProfessionalService.create({
          Title: vm.formDataProfesional.profession.trim(),
          Name: vm.formDataProfesional.company.trim(),
          Position: vm.formDataProfesional.currentPosition.trim(),
          FK_Contact: String(contactId),
        }, isAdminCreate, registrationToken);
        return;
      }
      if (vm.formDataUser.stage === 'Estudiante') {
        await StudentService.create({
          Level: vm.formDataEstudiante.studyLevel.trim(),
          Career: vm.formDataEstudiante.career.trim(),
          Name: vm.formDataEstudiante.university.trim(),
          Semester: Number(vm.formDataEstudiante.semester),
          FK_Contact: String(contactId),
        }, isAdminCreate, registrationToken);
      }
    } catch (e) {
      vm.message(e?.message || e, "error");
    }
  };

  const syncThematicAreasCreate = async (contactId, registrationToken) => {
    try {
      await Promise.all(
        vm.formDataArea.map((area) =>
          ContactThematicAreaService.create({
          FK_Contact: contactId,
          FK_ThematicArea: area,
          }, isAdminCreate, registrationToken)
        )
      );
    } catch (e) {
      vm.message(e?.message || e, "error")
    }
  };

  const createAccount = async () => {
    try {
      const contactPayload = {
        PrincipalEmail: vm.formDataUser.email.trim(),
        AlternativeEmail: vm.formDataUser.alternativeEmail?.trim() || null,
        HashedPassword: vm.formDataUser.password.trim(),
        FirstName: vm.formDataUser.first_Name.trim(),
        LastName: vm.formDataUser.last_Name?.trim() || null,
        NumeroIdentificacion: vm.formDataUser.identificationNumber.trim(),
        Phone: vm.formDataUser.cellPhone?.trim() || null,
        Phone2: vm.formDataUser.phone?.trim() || null,
        Birthdate: vm.formDataUser.birthdate,
        FK_City: vm.formDataUser.cityId ? String(vm.formDataUser.cityId) : null,
        FK_TypeId: String(vm.formDataUser.typeIdentificationNumber),
        FK_Country: String(vm.formDataUser.country),
        FK_Motivation: String(vm.formDataUser.motivation),
      };
      if (vm.formDataUser.role) {
        contactPayload.FK_Role = String(vm.formDataUser.role);
      }
      const userCreate = await ContactService.create(contactPayload, isAdminCreate);
      if (vm.logout(userCreate)) return { stopped: true };
      if (userCreate?.BondaOnly) {
        vm.resetAll();
        vm.message('La cedula ya existia en la aplicacion; usuario sincronizado en Bonda', 'success');
        if (vm.onClose) {
          vm.onBackToLogin();
          vm.onClose?.();
        }
        return { stopped: false, userCreate };
      }
      await saveProfessionalOrStudentCreate(userCreate?.Id, userCreate?.RegistrationToken);
      await syncThematicAreasCreate(userCreate?.Id, userCreate?.RegistrationToken);
      vm.resetAll();
      vm.message('Usuario registrado exitosamente', 'success');
      if (vm.onClose) {
        vm.onBackToLogin();
        vm.onClose?.();
      }
      return { stopped: false, userCreate };
    } catch (e) {
      vm.message(e?.message || e, "error");
      return { stopped: true }
    }
  };

  return {
    createAccount,
  };
};

export default CreateFlow;
